import { render, staticRenderFns } from "./detail-delivery.vue?vue&type=template&id=311ba026&scoped=true&"
import script from "./detail-delivery.vue?vue&type=script&lang=js&"
export * from "./detail-delivery.vue?vue&type=script&lang=js&"
import style0 from "./detail-delivery.vue?vue&type=style&index=0&id=311ba026&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311ba026",
  null
  
)

export default component.exports